const Footer = () => {
    return (
      <footer style={{ padding: '20px', textAlign: 'center', backgroundColor: '#333', color: '#fff' }}>
        <p>&copy; 2025 Gabriel / PointMicro.</p>
      </footer>
    );
  };
  
  export default Footer;
  